import {
  Component,
  OnDestroy,
  OnInit,
  SecurityContext,
  ViewChild,
} from '@angular/core';
import { IonAccordionGroup, ModalController } from '@ionic/angular';
import { AccessoriesService } from 'src/app/services/Accessories/accessory.service';
import { CachingService } from 'src/app/services/cache/caching.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { ApiService } from 'src/app/services/API/api.service';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';
import { EmiComponent } from '../emi/emi.component';
import { EventService } from 'src/app/services/Events/events.service';
import { ExtendedWarrantyComponent } from '../extended-warranty/extended-warranty.component';
import { CarExchangeComponent } from '../car-exchange/car-exchange.component';
import { AmcComponent } from '../amc/amc.component';
import { SummaryBreakupComponent } from '../summary-breakup/summary-breakup.component';
import { InsuranceComponent } from '../insurance/insurance.component';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit, OnDestroy {
  @ViewChild(SummaryBreakupComponent) summaryBreakup: SummaryBreakupComponent;
  @ViewChild('summaryAccordion') summaryAccordion: IonAccordionGroup;

  enableFinanceOptions = false;
  modelSpecifications: any;
  accessories = [];
  accessoryPackages = [];
  totalPrice: number;
  emiDetails: any;
  carExchange: any;
  extendedWarrantyDetails: any;
  mspDetails: any;
  applyHeightForCompatibility = false;
  insuranceDetails: any;
  offers: any;
  nearestDealer: any;
  Object: Object;
  showMore: boolean = false;
  constructor(
    private cachingService: CachingService,
    public accessoriesService: AccessoriesService,
    public globalService: GlobalService,
    private apiService: ApiService,
    private modalController: ModalController,
    private events: EventService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.events.subscribe('events', (data) => {
      this.subscribeToEvents(data);
    });

    let browser = this.checkBrowser();
    if (browser.name == 'Safari' && browser.version < '15') {
      this.applyHeightForCompatibility = true;
    }
    
    this.offers = this.globalService.selectedVariant.offer;
    this.getNearestDealer();
    this.getSpecifications();
  }

  //get Nearest dealer
  async getNearestDealer() {
    this.nearestDealer = await this.cachingService.getDataFromLocal('d_id');
    if (this.nearestDealer) {
      this.getOpeningHoursKeys();
    } else {
      // 'Nearest Dealer Not found'
    }
  }
  //get Nearest dealer opening hours and time
  getOpeningHoursKeys(): string[] {
    return Object.keys(this.nearestDealer?.week || {});
  }
  /**
   * return santized & secure string to render in innerhtml
   * @param text that needs to be sanitized
   * @returns
   */
  getSanitizedDynamicText(text): string {
    const sanitizedText = this.sanitizer.bypassSecurityTrustHtml(text);
    return this.sanitizer.sanitize(SecurityContext.HTML, sanitizedText);
  }

  checkBrowser() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: tem[1] || '' };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return { name: 'Opera', version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1],
    };
  }

  ngOnDestroy(): void {
  }

  subscribeToEvents(data) {
    let key = Object.keys(data)[0];
    switch (key) {
      case 'updatedTotalTaxPrices':
        this.summaryBreakup.getTotalPrice();
        break;
      case 'updatedPostcode':
        this.getNearestDealer();
        break;
      default:
        break;
    }
  }

  async getSpecifications() {
    let config = await this.cachingService.getDataFromSession('config');
    let modelSelected = await this.cachingService.getDataFromSession(
      'modelSelected'
    );
    this.modelSpecifications = [
      {
        label: 'MODEL',
        value: modelSelected.model_name,
        display: true,
      },
      {
        label: 'VARIANT',
        value: config.selectedVariant.variant_name,
        display: true,
      },
      {
        label: 'COLOR',
        value: config.colorSelected.color_name,
        display: true,
      },
      {
        label: 'TRANSMISSION & DRIVE',
        value:
          config.selectedVariant.transmission_code +
          ' ' +
          config.selectedVariant.drive,
        display: true,
      },
      {
        label: 'Drive Away Price',
        value: this.globalService.currencyFormatter(
          this.globalService.selectedConfigPrice?.drive_away_price
        ),
        class: 'bold',
        display: true,
      },
    ];

    this.arrangeAccessories();
    this.getEMIDetails();
    this.getExtendedWarranty();
    this.getCarExchange();
    this.getAMC();
    this.getInsuranceDetails();
  }
  async getEMIDetails() {
    let emi = await this.cachingService.getDataFromSession('emi_details');
    if (emi?.EstimatedMonthlyPayment) {
      this.emiDetails = emi;
    } else {
      this.emiDetails = undefined;
    }
  }

  async getInsuranceDetails() {
    let insuranceDetails = await this.cachingService.getDataFromSession(
      'insurancePlan_details'
    );
    if (insuranceDetails?.insuranceCost) {
      this.insuranceDetails = insuranceDetails;
    } else {
      this.insuranceDetails = undefined;
    }
    this.events.publish('events', { updatedInsuranceCost: null });
  }

  async getExtendedWarranty() {
    let extendedWarranty = await this.cachingService.getDataFromSession(
      'extendedWarranty_details'
    );
    if (extendedWarranty?.warrantyPrice) {
      this.extendedWarrantyDetails = extendedWarranty;
    } else {
      this.extendedWarrantyDetails = undefined;
    }
    this.events.publish('events', { updatedWarrantyCost: null });
  }
  async getAMC() {
    let amc_details = await this.cachingService.getDataFromSession(
      'amc_details'
    );
    this.mspDetails = amc_details;
    this.events.publish('events', { updatedMSPCost: null });
  }
  async getCarExchangeFromAPi() {
    const pin_no = await this.cachingService.getDataFromSession('pin_no');
    const requestBody = {
      pin_no: pin_no?.[this.globalService?.vehicleCode] ?? '',
    };
    this.apiService
      .post('configuration/get-exchange-values', requestBody)
      .then((res: any) => {
        if (res.message == 'success') {
          this.cachingService.setDataInSession(
            'exchange_values',
            res.response[0]
          );
          this.getCarExchange();
        } else {
          console.error('Exchange Values Error ');
        }
      })
      .catch((err) => {
        console.error('Exchange Values: ', err);
      });
  }

  async getCarExchange() {
    let carExchange = await this.cachingService.getDataFromSession(
      'exchange_values'
    );
    if (carExchange?.MinimumValue) {
      this.carExchange = carExchange;
    } else {
      this.carExchange = null;
    }
  }

  async arrangeAccessories() {
    let config = await this.cachingService.getDataFromSession('config');
    this.accessories = [];

    this.accessoryPackages = config.addedAccessoriesPacks;
    const accessoryGroups = Array.from(
      new Set(config.addedAccessories.map((item) => item.category_name))
    );
    for (let index = 0; index < accessoryGroups.length; index++) {
      let arr = config.addedAccessories.filter((el) => {
        return el.category_name == accessoryGroups[index];
      });
      let arrSortData = {
        groupName: accessoryGroups[index],
        accessories: this.globalService.sortByKey(arr, 'price'),
      };
      this.accessories.push(arrSortData);
    }
  }
  async removeAccessoryConfirmation(accessory, group) {
    let modelSelected = await this.cachingService.getDataFromSession(
      'modelSelected'
    );
    const accessoryName = accessory.marketing_name;
    const modelName = modelSelected.model_name;
    const content = this.translate.instant(
      'REMOVE_ACCESSORY_CONFIRMATION.CONTENT',
      { accessoryName, modelName }
    );
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      componentProps: {
        msg: {
          header: 'REMOVE_ACCESSORY_CONFIRMATION.HEADER',
          content: content,
          cancelText: 'REMOVE_ACCESSORY_CONFIRMATION.CANCEL',
          confirmText: 'REMOVE_ACCESSORY_CONFIRMATION.CONFIRM',
        },
      },
      backdropDismiss: false,
      cssClass: 'confirmation-modal',
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    data ? this.removeAccessory(accessory, group) : null;
  }
  removeAccessory(accessory, group) {
    this.accessoriesService.removeAccessory(accessory, 'fromSummary');
    let index = this.accessories.findIndex(
      (element) => element.groupName === group
    );
    let accessoriesList = this.accessories[index].accessories;
    accessoriesList = accessoriesList.filter((element) => {
      return element.accessories_id != accessory.accessories_id;
    });
    this.accessories[index].accessories =
      accessoriesList.length > 0
        ? accessoriesList
        : this.handleEmptyAccessory(group);
    //commented as rn total price gets updated once price api success response is fetched
    // instead using subscribe event to get total price
    // this.summaryBreakup.getTotalPrice();
  }

  handleEmptyAccessory(group) {
    this.accessories = this.accessories.filter((element) => {
      return element.groupName != group;
    });
  }

  closeSummary() {
    this.globalService.dismissModal();
  }
  closeAndOpenAccessories() {
    this.globalService.dismissModal({ data: 'openAccessories' });
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'accessorise_clicked',
      eAct: 'accessorize_now',
    });
  }
  saveConfiguration() {
    this.globalService.openLoginModal('save');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click',
      'Download Button'
    );
    this.apiService.visualizerAnalytics('save_and_share');
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'save_share',
      eAct: 'save_configuration',
    });
  }

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  testDrive() {
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'cta_clicked_visualizer',
      eAct: 'test_drive',
    });

    let testDriveUrl = this.globalService.getTestDriveUrl();
   
    this.apiService.visualizerAnalytics('test_drive');
    window.open(testDriveUrl, '_parent');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'Request a Test Drive'
    );
  }
  
  reserveVehicle() {
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::InternalTestDrive',
      this.globalService.configurator
        ? 'test drive configurator'
        : 'test drive visualizer'
    ); 
    window.open('https://www.jeep.com.au/avenger/reservation.html', '_parent');
  }

  proceedToBook() {
    this.globalService.openLoginModal('proceedToBook');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click',
      'Proceed to book'
    );
    this.apiService.visualizerAnalytics('proceed_to_book');
  }

  async showEmiCalculator() {
    this.globalService.activeTab = 'emi';
    const modal = await this.modalController.create({
      component: EmiComponent,
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-sidePanelModal-summary',
    });

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'EMI calculator'
    );
    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.globalService.activeTab = 'summary';
    if (data == 'success') {
      this.getEMIDetails();
      this.globalService.saveConfiguration('update');
    }
  }

  showAusOffers() {
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'View Offers'
    );
    let offersUrl = 'https://www.jeep.com.au/offers.html';
    window.open(offersUrl, '_parent');
  }

  async showExtendedWarranty() {
    this.globalService.activeTab = 'extendedWarranty';
    const modal = await this.modalController.create({
      component: ExtendedWarrantyComponent,
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-sidePanelModal-summary',
    });

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'Extended Warranty'
    );
    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.globalService.activeTab = 'summary';
    if (data == 'success') {
      this.getExtendedWarranty();
      this.globalService.saveConfiguration('update');
    }
  }
  async showAmcCalculator() {
    this.globalService.activeTab = 'amc';
    const modal = await this.modalController.create({
      component: AmcComponent,
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-sidePanelModal-summary',
    });

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'AMC Calculator'
    );
    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.globalService.activeTab = 'summary';
    if (data == 'success') {
      this.getAMC();
      this.globalService.saveConfiguration('update');
    }
  }
  /*
   * @author JP
   * For Insurance section
   */
  async showInsurance() {
    this.globalService.activeTab = 'insurance';
    const modal = await this.modalController.create({
      component: InsuranceComponent,
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-sidePanelModal-summary',
    });

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'Insurance Plan edit'
    );
    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.globalService.activeTab = 'summary';
    if (data == 'success') {
      this.getInsuranceDetails();
      this.globalService.saveConfiguration('update');
    }
  }
  async showCarExchange() {
    this.globalService.activeTab = 'carExchange';
    const modal = await this.modalController.create({
      component: CarExchangeComponent,
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-sidePanelModal-summary',
    });

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'Car Exchange'
    );
    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.globalService.activeTab = 'summary';
    if (data == 'success') {
      // this.getCarExchangeFromAPi();
      this.getCarExchange();
      this.globalService.saveConfiguration('update');
    }
  }

  /**
   * to remove EMI/Car Exchange/Extended Warranty from summary page
   * @param removeOptionSession : sessionData key for respective removeBtn
   */
  async removeBtn(removeOptionSession, label) {
    const header = await firstValueFrom(
      this.translate.get('REMOVE_BTN.HEADER', { label })
    );
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      componentProps: {
        msg: {
          header: header,
          content: 'REMOVE_BTN.CONTENT',
          cancelText: 'REMOVE_BTN.CANCEL',
          confirmText: 'REMOVE_BTN.CONFIRM',
        },
      },
      backdropDismiss: false,
      cssClass: 'confirmation-modal',
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data) {
      this.cachingService.removeDataFromSession(removeOptionSession);
      if (removeOptionSession == 'emi_details') {
        this.getEMIDetails();
      } else if (removeOptionSession == 'extendedWarranty_details') {
        this.getExtendedWarranty();
      } else if (removeOptionSession == 'exchange_values') {
        this.getCarExchange();
      } else if (removeOptionSession == 'amc_details') {
        this.getAMC();
      } else if (removeOptionSession == 'insurancePlan_details') {
        this.getInsuranceDetails();
      }
      this.globalService.saveConfiguration('update');
    }
  }

  toggleAccordionClick(value, i) {
    if (this.summaryAccordion?.value === 'addOffers') {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::View_Offers',
        'dropdown open'
      );
    } else if (this.summaryAccordion?.value === 'addedAcc') {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::View_Added_Acc',
        'drop down open'
      );
    } else if (this.summaryAccordion?.value === 'nearestDealer') {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::Your_Nearest_Dealer',
        'drop down open'
      );
    }
  }
}
